import { Add } from '@mui/icons-material';
import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Actions, Subjects } from '../../services/ability';
import ActionsBar from '../ActionsBar/ActionsBar';
import Permission from '../Permission';
import styles from './ContractsActions.module.scss';

const ContractsActions = () => {
    const navigate = useNavigate()
    return (
        <ActionsBar>
            <Grid container justifyContent="flex-between" alignContent="center" className={styles.Wrapper}>
                <Grid item xs={6} container alignContent="center">
                    <Typography variant="h3" color="primary">Contratos</Typography>
                </Grid>
                <Grid item xs={6} container justifyContent="flex-end">
                    <Permission action={Actions.CREATE} subject={Subjects.CONTRACT}>
                        <Tooltip title="Criar contrato">
                            <IconButton onClick={() => navigate("/create-contract")}>
                                <Add />
                            </IconButton>
                        </Tooltip>
                    </Permission>
                </Grid>
            </Grid>
        </ActionsBar>
    )
}

export default ContractsActions;
